import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { addUpdateScanTypeAPI, fetchScanTypesAPI, fetchScanTypesCalendarAPI } from '../../../services/scan-types-service';
import { fetchModalityTypes } from '../../../appRedux/sagas/common/modalityTypesSaga';

import { ADD_UPDATE_SCAN_TYPE, ADD_UPDATE_SCAN_TYPE_ERROR, ADD_UPDATE_SCAN_TYPE_START, ADD_UPDATE_SCAN_TYPE_SUCCESS, FETCH_SCAN_TYPES, FETCH_SCAN_TYPES_CALENDAR, FETCH_SCAN_TYPES_ERROR, FETCH_SCAN_TYPES_START, FETCH_SCAN_TYPES_SUCCESS, SET_SCAN_TYPES_PAGINATION } from '../../actions/common/scan-types-action';

const getModalityTypes = (state) => {
    let modalityObject = {};
    state.modalityTypes.modalityTypes.forEach(modality => {
        modalityObject[modality.modalityId] = modality.name;
    })
    return modalityObject;
};

export function* getScanTypes({ payload }) {
    try {        
        yield put({ type: FETCH_SCAN_TYPES_START })

        yield call(fetchModalityTypes);

        const response = yield call(fetchScanTypesAPI, payload);
        if (response.success) {

            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: SET_SCAN_TYPES_PAGINATION, pagination });

            const modalityTypes = yield select(getModalityTypes);
            if (Object.keys(modalityTypes).length > 0) {
                const scanTypes = (response.data || []).map((scanType) => {
                    return {
                        ...scanType,
                        modality: modalityTypes[scanType.modalityId] || null,
                    }
                })
                yield put({ type: FETCH_SCAN_TYPES_SUCCESS, scanTypes })
            } else {
                yield put({ type: FETCH_SCAN_TYPES_SUCCESS, scanTypes: response.data.scanTypes })
            }
        } else {
            yield put({ type: FETCH_SCAN_TYPES_ERROR, error: response.error })
            message.error('Failed to fetch Scan Types!');
        }
    } catch (error) {
        yield put({ type: FETCH_SCAN_TYPES_ERROR, error })
        message.error('Failed to fetch Scan Types!');
    }
}

export function* getScanTypesCalendar() {
    try {
        yield put({ type: FETCH_SCAN_TYPES_START })

        const response = yield call(fetchScanTypesCalendarAPI);
        if (response.success) {
            const responseScanTypes = Array.isArray(response.data)
                ? response.data
                : response.data.scanTypes || [];

            yield put({ type: FETCH_SCAN_TYPES_SUCCESS, scanTypes: responseScanTypes })
        } else {
            yield put({ type: FETCH_SCAN_TYPES_ERROR, error: response.error })
            message.error('Failed to fetch Scan Types!');
        }
    } catch (error) {
        yield put({ type: FETCH_SCAN_TYPES_ERROR, error })
        message.error('Failed to fetch Scan Types!');
    }
}

export function* addUpdateScanType({ payload }) {
    try {
        const { scanType, closeModal } = payload;
        yield put({ type: ADD_UPDATE_SCAN_TYPE_START })
        const response = yield call(addUpdateScanTypeAPI, scanType);
        if (response.success) {
            yield put({ type: ADD_UPDATE_SCAN_TYPE_SUCCESS, scanType: { ...scanType, ...response.data } })
            message.success("Scan type saved successfully");
            closeModal();
        } else {
            yield put({ type: ADD_UPDATE_SCAN_TYPE_ERROR, error: response.error })
            message.error('Failed to save Scan Type!');
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_SCAN_TYPE_ERROR, error })
        message.error('Failed to save Scan Type!');
    }
}

function* scanTypesWatcher() {
    yield takeLatest(FETCH_SCAN_TYPES, getScanTypes)
    yield takeLatest(FETCH_SCAN_TYPES_CALENDAR, getScanTypesCalendar)
    yield takeLatest(ADD_UPDATE_SCAN_TYPE, addUpdateScanType)
}

export default function* rootSaga() {
    yield all([
        scanTypesWatcher(),
    ]);
}
